<footer class="app-footer">
  <div class="footer-content">
    <p class="copyright">{{ 'FEATURES.FOOTER.COPYRIGHT' | transloco: { year: year } }}</p>
    <nav class="footer-links">
      <a [href]="Constants.PRIVACY_POLICY_URL" target="_blank" rel="noopener noreferrer">{{ 'FEATURES.FOOTER.PRIVACY_POLICY' | transloco }}</a>
      <a [href]="Constants.TERMS_AND_CONDITIONS_URL" target="_blank" rel="noopener noreferrer">{{ 'FEATURES.FOOTER.TERMS_AND_CONDITIONS' | transloco }}</a>
    </nav>
  </div>
</footer>
